import { allCountriesListV2, localCountriesList } from '@/pages/entity/models/countries-list'
import appConfig from '@/utils/appConfig';

export const getSocialName = (link) => {
  const lowerLink = link.toLowerCase()

  if (lowerLink.includes('instagram.com')) return 'Instagram'
  if (lowerLink.includes('twitter.com') || lowerLink.includes('x.com')) return 'X'
  if (lowerLink.includes('discord.gg')) return 'Discord'
  if (lowerLink.includes('facebook.com')) return 'Facebook'
  if (lowerLink.includes('github.com')) return 'Github'
  if (lowerLink.includes('linkedin.com')) return 'Linkedin'
  if (lowerLink.includes('medium.com')) return 'Medium'
  if (lowerLink.includes('reddit.com')) return 'Reddit'
  if (lowerLink.includes('t.me') || lowerLink.includes('telegram.me')) return 'Telegram'
  if (lowerLink.includes('teletype.in')) return 'Teletype'
  if (lowerLink.includes('threads.net')) return 'Threads'
  if (lowerLink.includes('tiktok.com')) return 'TikTok'
  if (lowerLink.includes('vk.com')) return 'VK'
  if (lowerLink.includes('weibo.com')) return 'Weibo'
  if (lowerLink.includes('youtube.com') || lowerLink.includes('youtu.be')) return 'YouTube'

  return ''
}

export const getCountryByCode = (code) => {
  return allCountriesListV2.concat(localCountriesList).find(country => country.code === code || country.name === code)
}

export const setOptionsToChipsFilters = ({ getters, key, options }) => {
  return getters.getChipsFilters.map(e =>
    e.key === key ? { ...e, options } : e,
  )
}

export const resolveEntityPriority = ({
  owner = '',
  entityId = '',
  entitiesData = [],
  priority = JSON.parse(appConfig.VUE_APP_ENTITY_PRIORITY),
}) => {
  for (const key of priority) {
    entitiesData = entitiesData.filter(e => e)
    if (key === 'owner' && owner) {
      const found = entitiesData.find(
        el => el.name?.toLowerCase() === owner?.toLowerCase()
      )
      if (found) return found
    }
    if (key === 'entity' && entityId) {
      const found = entitiesData.find(el => el.id === entityId)
      if (found) return found
    }
  }
  if (owner) return { name: owner }
  return null
}

export const updateArrayWithEntity = ({ array = [], entitiesData = [], priority }) => {
  return array.map(el => {
    const resolvedEntity = resolveEntityPriority({
      owner: el.owner,
      entityId: el.entity,
      entitiesData,
      priority
    })

    return {
      ...el,
      resolvedEntity,
    }
  })
}
